export class ServerError extends Error {
  public readonly error;

  constructor(error: unknown) {
    super('');

    this.error = error;
    this.name = 'ServerError';

    Object.setPrototypeOf(this, ServerError.prototype);
  }
}
